const WEAPON_STATS = {
  club: { dice: '1d4', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  dagger: { dice: '1d4', type: 'piercing', ability: 'dexterity', attackType: 'meleeWeapon', reach: 5, properties: ['Finesse', 'Light', 'Thrown'], range: { normal: 20, long: 60 } },
  greatclub: { dice: '1d8', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  handaxe: { dice: '1d6', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 5, properties: ['Light', 'Thrown'], range: { normal: 20, long: 60 } },
  javelin: { dice: '1d6', type: 'piercing', ability: 'strength', attackType: 'meleeWeapon', reach: 5, properties: ['Thrown'], range: { normal: 30, long: 120 } },
  lightHammer: { dice: '1d4', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5, properties: ['Light', 'Thrown'], range: { normal: 20, long: 60 } },
  mace: { dice: '1d6', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  quarterstaff: { dice: '1d6', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  sickle: { dice: '1d4', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 5, properties: ['Light'] },
  spear: { dice: '1d6', type: 'piercing', ability: 'strength', attackType: 'meleeWeapon', reach: 5, properties: ['Thrown'], range: { normal: 20, long: 60 } },
  lightCrossbow: { dice: '1d8', type: 'piercing', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 80, long: 320 } },
  dart: { dice: '1d4', type: 'piercing', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 20, long: 60 }, properties: ['Finesse', 'Thrown'] },
  shortbow: { dice: '1d6', type: 'piercing', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 80, long: 320 } },
  sling: { dice: '1d4', type: 'bludgeoning', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 30, long: 120 } },
  battleaxe: { dice: '1d8', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  flail: { dice: '1d8', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  glaive: { dice: '1d10', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 10 },
  greataxe: { dice: '1d12', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  greatsword: { dice: '2d6', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  halberd: { dice: '1d10', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 10 },
  lance: { dice: '1d12', type: 'piercing', ability: 'strength', attackType: 'meleeWeapon', reach: 10 },
  longsword: { dice: '1d8', type: 'slashing', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  maul: { dice: '2d6', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  morningstar: { dice: '1d8', type: 'piercing', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  pike: { dice: '1d10', type: 'piercing', ability: 'strength', attackType: 'meleeWeapon', reach: 10 },
  rapier: { dice: '1d8', type: 'piercing', ability: 'dexterity', attackType: 'meleeWeapon', reach: 5, properties: ['Finesse'] },
  scimitar: { dice: '1d6', type: 'slashing', ability: 'dexterity', attackType: 'meleeWeapon', reach: 5, properties: ['Finesse', 'Light'] },
  shortsword: { dice: '1d6', type: 'piercing', ability: 'dexterity', attackType: 'meleeWeapon', reach: 5, properties: ['Finesse', 'Light'] },
  trident: { dice: '1d6', type: 'piercing', ability: 'strength', attackType: 'meleeWeapon', reach: 5, properties: ['Thrown'], range: { normal: 20, long: 60 } },
  warPick: { dice: '1d8', type: 'piercing', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  warhammer: { dice: '1d8', type: 'bludgeoning', ability: 'strength', attackType: 'meleeWeapon', reach: 5 },
  whip: { dice: '1d4', type: 'slashing', ability: 'dexterity', attackType: 'meleeWeapon', reach: 10, properties: ['Finesse', 'Reach'] },
  blowgun: { dice: '1', type: 'piercing', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 25, long: 100 } },
  handCrossbow: { dice: '1d6', type: 'piercing', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 30, long: 120 } },
  heavyCrossbow: { dice: '1d10', type: 'piercing', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 100, long: 400 } },
  longbow: { dice: '1d8', type: 'piercing', ability: 'dexterity', attackType: 'rangedWeapon', range: { normal: 150, long: 600 } }
};

const WEAPON_ALIASES = {
  'light hammer': 'lightHammer',
  'light crossbow': 'lightCrossbow',
  'hand crossbow': 'handCrossbow',
  'heavy crossbow': 'heavyCrossbow',
  'war pick': 'warPick',
  'short sword': 'shortsword',
  'short bow': 'shortbow',
  'long bow': 'longbow'
};

const asRecord = (value) => (value && typeof value === 'object' ? value : null);

const clone = (value) => {
  if (Array.isArray(value)) return value.map((entry) => clone(entry));
  if (value && typeof value === 'object') return { ...value };
  return value;
};

const titleWords = (value) => String(value || '')
  .replace(/([a-z])([A-Z])/g, '$1 $2')
  .replace(/[^a-z0-9+]+/gi, ' ')
  .trim()
  .toLowerCase();

const weaponLookupKey = (value) => {
  const withoutParentheticals = String(value || '').replace(/\([^)]*\)/g, ' ');
  const normalized = titleWords(withoutParentheticals)
    .replace(/^\+\s*\d+\s+/, '')
    .replace(/\b(?:watch loan|magic|magical|weapon|loaned|borrowed)\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (WEAPON_ALIASES[normalized]) return WEAPON_ALIASES[normalized];
  const compact = normalized.replace(/\s+/g, '');
  if (WEAPON_STATS[compact]) return compact;

  const candidates = [
    ...Object.entries(WEAPON_ALIASES).map(([label, key]) => ({ label, key })),
    ...Object.keys(WEAPON_STATS).map((key) => ({ label: titleWords(key), key }))
  ].sort((a, b) => b.label.length - a.label.length);
  const padded = ` ${normalized} `;
  const baseWeapon = candidates.find(({ label }) => padded.includes(` ${label} `));
  return baseWeapon?.key || normalized;
};

const collectSources = (action) => {
  const queue = [asRecord(action)];
  const visited = new Set();
  const sources = [];

  while (queue.length > 0) {
    const current = queue.shift();
    if (!current || visited.has(current)) continue;
    visited.add(current);
    sources.push(current);
    [
      current.weaponData,
      current.originalAction,
      current.action,
      current.actionData,
      current.definition,
      current.attack
    ].forEach((candidate) => {
      const record = asRecord(candidate);
      if (record && !visited.has(record)) queue.push(record);
    });
  }

  return sources;
};

const sourceName = (source) => (
  source?.name
  || source?.label
  || source?.title
  || source?.weaponName
  || source?.itemName
  || ''
);

export const inferKnownWeaponStats = (action) => {
  const actionType = String(action?.type || action?.actionType || '').trim().toLowerCase();
  const isStructuredSpell = actionType === 'spell'
    || action?.spellLevel !== undefined
    || action?.castingTime !== undefined
    || action?.components !== undefined
    || action?.school !== undefined
    || (action?.spellData && typeof action.spellData === 'object');

  if (isStructuredSpell) {
    // date_of_change: 2026-08-20
    // WHAT: Prevent structured spell actions from entering name-based weapon inference.
    // WHY: Spell component names can contain weapon words (for example, "Magic Missile dart");
    // treating those words as equipment silently adds an unrelated physical damage component.
    return null;
  }

  for (const source of collectSources(action)) {
    const key = weaponLookupKey(sourceName(source));
    if (WEAPON_STATS[key]) return clone(WEAPON_STATS[key]);
  }
  return null;
};

export const inferWeaponMagicBonus = (action) => {
  let inferred = 0;
  for (const source of collectSources(action)) {
    const bonusCandidates = [
      source?.magicBonus,
      source?.magicalBonus,
      source?.enhancementBonus,
      source?.weaponBonus,
      source?.attack?.magicBonus,
      source?.attack?.magicalBonus,
      source?.attack?.enhancementBonus
    ];
    for (const value of bonusCandidates) {
      const parsed = Number(value);
      if (Number.isFinite(parsed)) inferred = Math.max(inferred, parsed);
    }

    const name = String(sourceName(source));
    const match = name.match(/(?:^|\s)\+([1-3])(?=\s|$|[A-Za-z])/);
    if (match) inferred = Math.max(inferred, Number(match[1]));
  }
  return inferred;
};

const numberOrZero = (value) => (Number.isFinite(Number(value)) ? Number(value) : 0);

const appendModifier = (dice, modifier) => {
  const mod = numberOrZero(modifier);
  if (!mod) return dice;
  return `${dice}${mod > 0 ? '+' : ''}${mod}`;
};

const explicitAbility = (action) => {
  for (const source of collectSources(action)) {
    const ability = String(
      source?.damageAbility
      || source?.ability
      || source?.attack?.ability
      || ''
    ).trim().toLowerCase();
    if (['strength', 'str'].includes(ability)) return 'strength';
    if (['dexterity', 'dex'].includes(ability)) return 'dexterity';
  }
  return null;
};

const hasProperty = (action, property) => {
  const target = String(property || '').toLowerCase();
  return collectSources(action).some((source) => [
    source?.properties,
    source?.attack?.properties,
    source?.weaponData?.properties
  ].some((value) => Array.isArray(value) && value.some((entry) => String(entry || '').toLowerCase() === target)));
};

export const inferWeaponDamageEntries = (action, options = {}) => {
  const stats = inferKnownWeaponStats(action);
  if (!stats) return [];

  const abilityFor = typeof options.abilityModifierForAbility === 'function'
    ? options.abilityModifierForAbility
    : () => 0;
  const statAbility = explicitAbility(action) || stats.ability || 'strength';
  let abilityModifier = numberOrZero(abilityFor(statAbility));
  const finesse = hasProperty(action, 'finesse') || (Array.isArray(stats.properties) && stats.properties.some((entry) => String(entry).toLowerCase() === 'finesse'));
  if (finesse) {
    abilityModifier = Math.max(
      abilityModifier,
      numberOrZero(abilityFor('strength')),
      numberOrZero(abilityFor('dexterity'))
    );
  }

  const magicBonus = inferWeaponMagicBonus(action);
  return [{
    dice: appendModifier(stats.dice, abilityModifier + magicBonus),
    type: stats.type,
    inferred: true,
    source: 'weapon_reference'
  }];
};

export const mergeWeaponBaseDamageEntries = (action, entries = [], options = {}) => {
  const explicitEntries = Array.isArray(entries) ? entries.filter(Boolean) : [];
  const inferredEntries = inferWeaponDamageEntries(action, options);
  if (inferredEntries.length === 0) return explicitEntries;
  if (explicitEntries.length === 0) return inferredEntries;

  const physicalTypes = new Set(['bludgeoning', 'piercing', 'slashing']);
  const hasBaseWeaponDamage = explicitEntries.some((entry) => (
    physicalTypes.has(String(entry?.type || entry?.damageType || '').trim().toLowerCase())
  ));
  return hasBaseWeaponDamage
    ? explicitEntries
    : [...inferredEntries, ...explicitEntries];
};

export const inferWeaponRange = (action) => {
  const stats = inferKnownWeaponStats(action);
  return stats?.range ? clone(stats.range) : null;
};

export const inferWeaponReach = (action) => {
  const stats = inferKnownWeaponStats(action);
  return Number.isFinite(Number(stats?.reach)) ? Number(stats.reach) : null;
};

export const inferWeaponAttackType = (action) => {
  const stats = inferKnownWeaponStats(action);
  return stats?.attackType || null;
};
